import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { get } from 'lodash';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ProgressSpinner from '@peoplenet/vi-components-ui/src/Loading/ProgressSpinner';
import { connect } from 'react-redux';
import { doesRequireSetup } from './util';
import { getInfo } from './SecurityActions';
import { getSettings } from '../customer/CustomerActions';
import { getSystemSettings } from '../system/SystemActions';

class SecurityWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.isInitialMount = true;
  }

  componentDidMount() {
    this.waitForGeotabSession().then(() => {
      this.loadData();
    });
    
    this.handleFocus = () => {
      if (this.isInitialMount) {
        this.isInitialMount = false;
        return;
      }
      this.loadData();
    };
    window.addEventListener('viAddinPageFocus', this.handleFocus);
  }

  componentWillUnmount() {
    window.removeEventListener('viAddinPageFocus', this.handleFocus);
  }

  waitForGeotabSession() {
    return new Promise((resolve) => {
      const checkSession = () => {
        if (window.geotabSession && window.geotabSession.userName) {
          resolve();
        } else {
          setTimeout(checkSession, 50);
        }
      };
      checkSession();
    });
  }

  loadData() {
    this.props.getInfo();
    this.props.getSystemSettings();
    this.props.getSettings();
  }

  isUserAllowed() {
    const { security } = this.props;

    if (!security.logged) {
      return false;
    }

    if (!doesRequireSetup()) {
      return true;
    }

    const setup = get(security, 'userInfo.setup', {});

    if (!setup.hasAllGroups) {
      return false;
    }

    return setup.isAdmin || setup.isSupervisor;
  }

  render() {
    const { security, system, customer } = this.props;

    if (security.loading || system.loading || customer.loading) {
      return <ProgressSpinner />;
    }

    if (!this.isUserAllowed()) {
      return (
        <Grid container className="media">
          <Grid item xl={3} lg={6} md={6} sm={10} xs={10}>
            <Paper className="papercard" elevation={2}>
              <Icon className="papercard__erroricon">report</Icon>
              <Translate value="unauthorized" />
            </Paper>
          </Grid>
        </Grid>
      );
    }
    return <div>{this.props.children}</div>;
  }
}

SecurityWrapper.propTypes = {
  getInfo: PropTypes.func.isRequired,
  getSystemSettings: PropTypes.func.isRequired,
  getSettings: PropTypes.func.isRequired,

  security: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    logged: PropTypes.bool.isRequired,
    userInfo: PropTypes.shape({
      setup: PropTypes.shape({
        isAdmin: PropTypes.bool,
        isSupervisor: PropTypes.bool,
        hasAllGroups: PropTypes.bool,
        hasDvrToolkitPassword: PropTypes.bool,
      }),
    }),
  }),

  customer: PropTypes.shape({
    loading: PropTypes.bool,
  }),
  system: PropTypes.shape({
    loading: PropTypes.bool,
  }),
  children: PropTypes.node.isRequired,
};

export const mapStateToProps = (state) => ({
  security: state.security,
  system: state.system,
  customer: state.customer,
});

export const mapDispatchToProps = (dispatch) => ({
  getInfo: () => dispatch(getInfo()),
  getSystemSettings: () => dispatch(getSystemSettings()),
  getSettings: () => dispatch(getSettings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecurityWrapper);
